import { render, staticRenderFns } from "./private.vue?vue&type=template&id=d0efb1c4&scoped=true&"
import script from "./private.vue?vue&type=script&lang=js&"
export * from "./private.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0efb1c4",
  null
  
)

export default component.exports